<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Installations</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body">

          <button 
            class="button is-small mb-3" 
            @click="managingTypes = true">
            Manage Installation Types
          </button>

          <article 
            v-if="!loading && installations.length == 0" 
            class="message is-info is-fullwidth mt-3">
            <div class="message-body">
              There are no installations.
            </div>
          </article>

          <v-fade-transition mode="out-in">
            <div 
              v-if="loading" 
              class="is-relative">
              <v-spin-loader :value="true">
                <div class="py-6"></div>
              </v-spin-loader>
            </div>

            <table
              v-else 
              class="table is-fullwidth is-hoverable">
              <thead>
                <tr>
                  <th 
                    class="text--nowrap"
                    v-for="(header, headerIndex) in headers" 
                    :key="headerIndex">
                    {{ header.label }}
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tfoot>
                <tr>
                  <td :colspan="headers.length + 1">
                    <div class="centered">
                      <button
                        v-if="!adding"
                        @click="adding = true" 
                        class="button is-primary is-small">
                        Add a new installation
                      </button>
                    </div>
                  </td>
                </tr>
              </tfoot>

              <tbody>
                <tr 
                  class="v-centered"
                  v-for="installation in installations" 
                  :key="installation.id">

                  <template v-if="editingId != installation.id">
                    <td>
                      {{ installation.installation_name }}
                    </td>
                    <td>
                      {{ installation.installation_type.installation_type_name }}
                    </td>
                    <td>
                      {{ installation.unit ? installation.unit.unit_display_name : '' }}
                    </td>
                    <td>
                      {{ installation.unit_price | currency(2) }}
                    </td>
                    <td>
                      {{ installation.waste_pct | percentage }}
                    </td>
                  </template>

                  <template v-else>
                    <td>
                      <v-text-field 
                        required
                        placeholder="Enter Installation Name"
                        v-model="installation.installation_name">
                      </v-text-field>
                    </td>
                    <td>
                      <v-select
                        required
                        :options="installationTypes"
                        item-text="installation_type_name"
                        item-value="id"
                        v-model="installation.installation_type_id"
                      />
                    </td>
                    <td>
                      <v-select
                        required
                        :options="units"
                        item-text="unit_display_name"
                        item-value="id"
                        v-model="installation.unit_id"
                      />
                    </td>
                    <td>
                      <v-text-field 
                        placeholder="Enter Installation Unit Price"
                        type="number"
                        v-model="installation.unit_price">
                      </v-text-field>
                    </td>
                    <td>
                      <v-text-field 
                        placeholder="Installation waste percentage"
                        type="number"
                        v-model="installation.waste_pct">
                      </v-text-field>
                    </td>
                  </template>

                  <td>
                    <div class="buttons buttons-right">
                      <template v-if="editingId != installation.id">
                        <button
                          @click="editingId = installation.id" 
                          class="button is-small">
                          <span class="icon">
                            <i class="fas fa-edit has-text-grey"></i>
                          </span>
                        </button>
                        <button
                          @click="deleteInstallation(installation.id)" 
                          class="button is-small">
                          <span class="icon">
                            <i class="fas fa-trash has-text-grey"></i>
                          </span>
                        </button>
                      </template>
                      <template v-else>
                        <button
                          @click="update(installation)" 
                          class="button is-primary is-small">
                          <span class="icon">
                            <i class="fas fa-save"></i>
                          </span>
                        </button>
                        <button
                          @click="editingId = null" 
                          class="button is-small">
                          <span class="icon">
                            <i class="fas fa-times has-text-grey"></i>
                          </span>
                        </button>
                      </template>
                    </div>
                  </td>
                </tr>

                <tr class="v-centered" v-if="adding">
                  <td>
                    <v-text-field 
                      required
                      placeholder="Enter Installation Name"
                      v-model="installation.installation_name"
                    />
                  </td>
                  <td>
                    <v-select
                      required
                      :options="installationTypes"
                      item-text="installation_type_name"
                      item-value="id"
                      v-model="installation.installation_type_id"
                    />
                  </td>
                  <td>
                    <v-select
                      required
                      :options="units"
                      item-text="unit_display_name"
                      item-value="id"
                      v-model="installation.unit_id"
                    />
                  </td>
                  <td>
                    <v-text-field 
                      placeholder="Enter Installation Unit Price"
                      type="number"
                      v-model="installation.unit_price"/>
                  </td>
                  <td>
                    <v-text-field 
                      placeholder="Installation waste percentage"
                      type="number"
                      v-model="installation.waste_pct">
                    </v-text-field>
                  </td>
                  <td>
                    <div class="buttons buttons-right">
                      <button
                        @click="add" 
                        class="button is-primary is-small">
                        <span class="icon">
                          <i class="fas fa-save"></i>
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>  
          </v-fade-transition>

        </div>

        <!-- <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addCutSheetStep()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer> -->

      </div>
    </div>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>

    <manage-installation-types-modal 
      v-model="managingTypes"/>

  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VSpinLoader from '@/components/base/VSpinLoader'
import VConfirmModal from '@/components/base/VConfirmModal'
import VFadeTransition from '@/components/transitions/VFadeTransition'

import ManageInstallationTypesModal from '@/components/estimations/ManageInstallationTypesModal'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { 
    VSelect, VTextField, VSpinLoader, VConfirmModal, VFadeTransition,
    ManageInstallationTypesModal 
  },
  data() {
    return {
      headers: [
        { label: 'Name' },
        { label: 'Type' },
        { label: 'Unit Type' },
        { label: 'Unit Price' },
        { label: 'Waste' } 
      ],
      installation: {
        installation_name: '',
        installation_type_id: '',
        unit_id: '',
        unit_price: '',
        waste_pct: ''
      },
      valid: false,
      adding: false,
      editingId: null,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this installation?',
        type: 'danger'
      },
      deleteConfirmedCb: null,
      managingTypes: false
    }
  },
  computed: {
    ...mapState("installations", [
      "installations", "installationTypes", "loading"
    ]),
    ...mapState("units", ["units"])
  },
  watch: {
    value(v) {
      if (!v) {
        this.adding = false;
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("installations", [
      "getInstallations","addInstallation", 
      "deleteInstallation", "updateInstallation",
      "toggleAllSelected", "getInstallationTypes"
    ]),
    ...mapMutations("installations", [
      "selectAll", "deselectAll", "toggleSelected"
    ]),
    ...mapActions("units", ["getUnits"]),
    initialize() {
      if (this.installations.length == 0) {
        this.getInstallations();
      }
      if (this.units.length == 0) {
        this.getUnits();
      }
      if (this.installationTypes == 0) {
        this.getInstallationTypes();
      }
    },
    add() {
      this.addInstallation(this.installation).then(() => {
        this.adding = false;
        this.clearData();
      });
    },
    update(installation) {
      this.updateInstallation(
        { installationId: installation.id, data: installation }
      ).then(() => {
        this.editingId = null;
      })
    },
    launchConfirmDelete(id) {
      this.deleteConfirmedCb = () => {
        this.deleteInstallation(id);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.message = 'Are you sure you want to delete this installation?';
      this.confirmDelete.state = true;
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';

.table tfoot td .centered {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.modal-content {
  width: 1000px;
}

.modal-card {
  border-radius: 6px;
  width: 1000px;
}
</style>
